import _classCallCheck from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useState, useEffect } from 'react';
export default function useFindUser(baseUrl) {
  var _useState = useState(),
      user = _useState[0],
      setUser = _useState[1];

  var _useState2 = useState(undefined),
      currentMembership = _useState2[0],
      setCurrentMembership = _useState2[1];

  var _useState3 = useState(true),
      isLoading = _useState3[0],
      setLoading = _useState3[1];

  useEffect(function () {
    function findUser(_x) {
      return _findUser.apply(this, arguments);
    }

    function _findUser() {
      _findUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new UsersService().me(baseUrl).then(function (user) {
                  setUser(user);

                  if (user.memberships && user.memberships.length > 0) {
                    setCurrentMembership(user.memberships[0]);
                  }

                  setLoading(false);
                })["catch"](function (err) {
                  var _err$response;

                  setLoading(false); // This incicate that the user is not connected

                  if (err.isAxiosError && ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) !== 401) {
                    throw err;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _findUser.apply(this, arguments);
    }

    findUser(baseUrl);
  }, [baseUrl]);
  return {
    user: user,
    setUser: setUser,
    isLoading: isLoading,
    currentMembership: currentMembership,
    setCurrentMembership: setCurrentMembership
  };
}
export var UsersService = /*#__PURE__*/function () {
  function UsersService() {
    _classCallCheck(this, UsersService);
  }

  _createClass(UsersService, [{
    key: "me",
    value: function () {
      var _me = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(baseUrl) {
        var yalUser, user, headers;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                yalUser = localStorage.getItem('yalUser');
                user = yalUser ? JSON.parse(yalUser) : null;
                headers = {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                };

                if (user && user.accessToken) {
                  headers['Authorization'] = "Bearer ".concat(user.accessToken);
                }

                return _context3.abrupt("return", fetch("".concat(baseUrl, "/users/me"), {
                  headers: headers,
                  method: 'GET'
                }).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
                    var responseBody;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return response.json();

                          case 2:
                            responseBody = _context2.sent;

                            if (!response.ok) {
                              _context2.next = 5;
                              break;
                            }

                            return _context2.abrupt("return", responseBody);

                          case 5:
                            return _context2.abrupt("return", Promise.reject(responseBody));

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function me(_x2) {
        return _me.apply(this, arguments);
      }

      return me;
    }()
  }]);

  return UsersService;
}();